import React, { useEffect } from 'react';
import classes from './SwitchMode.module.scss';
import { Divider, Button } from 'antd';
import cn from 'classnames';

export const SwitchMode = (props) => {
  const {
    options,
    onChange,
    defaultValue,
    value,
    className,
    wrapperClassName,
    split = true,
  } = props;
  const [mode, setMode] = React.useState(defaultValue || value);

  const onChangeMode = (mode) => {
    setMode(mode);
    if (onChange) {
      onChange(mode);
    }
  };

  useEffect(() => {
    if (value !== undefined && value !== mode) {
      setMode(value);
    }
  }, [value]);

  return (
    <div className={cn(classes.switchMode, className)}>
      <ul className={cn(classes.wrapper, wrapperClassName)}>
        {options.map((option, index) => {
          const { label, value: valueFromOption, icon, onClick } = option;
          return (
            <React.Fragment key={index}>
              <Button
                onClick={() => {
                  if (onClick) {
                    onClick();
                  } else {
                    onChangeMode(valueFromOption);
                  }
                }}
                type="text"
                icon={icon}
                className={cn(classes.item, {
                  [classes.active]: mode === valueFromOption,
                })}>
                {label}
              </Button>
              {split && index < options.length - 1 && (
                <Divider className={classes.divider} type="vertical" />
              )}
            </React.Fragment>
          );
        })}
      </ul>
    </div>
  );
};
